import { publicRequest } from './api/auth';

class LoginValidationService {
    hasLoginValidation(tenant) {
        return publicRequest.get(`/api/login/validation/?tenant=${tenant}&code=LOGIN_VALIDATION`);
    }
    sendLoginValidationCode(tenant, username) {
        return publicRequest.post(`/api/login/validation/?tenant=${tenant}&code=LOGIN_VALIDATION&username=${username}`);
    }
    getLoginType(tenant) {
        return publicRequest.get(`/api/login/type/?tenant=${tenant}`)
    }
    loginBrandingSetting(tenant){
        return publicRequest.get(`/api/login/page-setting/?tenant=${tenant}`)
    }
    getUrbanRenewalLogo(tenant) {
        return publicRequest.get(`/api/urbanrenewal/logo/?tenant=${tenant}`)
    }
}

export default new LoginValidationService();
